import {axiosInstance} from "@/plugins/axios";
import {Item, ItemNewHSCodes} from "@/modules/item/types";

export interface ItemsFilter {
  type: null,
  search: null,
  limit: null,
  offset: null,
  pageLimit: null,
  avoid_type: null,
  show_enabled: boolean | null,
  search_condition?: string
}

export async function disableItem(id: string) {
  await axiosInstance.delete(`items/${id}`);
}

export async function restoreItem(item: Item) {
  await axiosInstance.put(`items/restore`, item);
}

export async function saveItem(item: Item) {
  await axiosInstance.post(`items`, item);
}

export async function updateItem(item: ItemNewHSCodes) {
  await axiosInstance.post(`items/harmonized_system_codes/${item.id}`, item);
}

export async function getItems(filter: ItemsFilter) {
  let url = `items?`;

  if (filter.type) {
    url += `type=${filter.type}&`
  }

  if (filter.search) {
    url += `search=${filter.search}&`
  }

  if (filter.limit){
    url += `limit=${filter.limit}&`
  }

  if (filter.pageLimit){
    url += `offset=${filter.offset}&page_limit=${filter.pageLimit}&`
  }

  if (filter.avoid_type) {
    url += `avoid_type=${filter.avoid_type}&`
  }

  if (filter.show_enabled) {
    url += `show_enabled=${filter.show_enabled}&`
  }

  if (filter.search_condition) {
    url += `search_condition=${filter.search_condition}`
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getItemTypes() {
  const url = `items/types`;
  const response = await axiosInstance.get(url);
  return response.data;
}

export async function saveItems(items: Item[]) {
  await axiosInstance.post(`items/create_or_update_many`, {
    items: items
});
}
